module.exports = __webpack_public_path__ + "static/media/img1.c7bc2b61.jpg";